import { useState, useEffect } from "react";
import { message } from "antd";

const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const checkOnlineStatus = async () => {
    try {
      // Try to fetch a small file that allows CORS
      const response = await fetch("https://1.1.1.1/cdn-cgi/trace", {
        method: "GET",
        cache: "no-store",
      });
      return response.ok;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const updateStatus = async () => {
      const online = await checkOnlineStatus();
      setIsOnline(online);
      // if (!online) message.error("❌ You are Offline", 2);
      // else message.success("✅ Back Online", 2);
    };

    // Initial check
    updateStatus();

    // Listen for browser events
    const handleOnline = () => updateStatus();
    const handleOffline = () => updateStatus();

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Periodic check (for when events don't fire)
    const interval = setInterval(updateStatus, 30000); // every 30s

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(interval);
    };
  }, []);

  return isOnline;
};

export default useNetworkStatus;
